export type ModeloIzzaGPTModel = {
    modelo: string
}

export const ModeloIzzaGPTInicial: ModeloIzzaGPTModel = {
    modelo: "",
}
